const OBJECT_ID_RE = /^[a-f\d]{24}$/i;

/**
 * Wallet / QR profile links use `https://<api>/profiles/<slug>?id=<mongoId>`.
 * In-app handling requires a valid Mongo ObjectId in `id` (public profile API is id-based).
 */
export function extractProfileUserIdFromIncomingUrl(raw: string | null | undefined): string | null {
	if (!raw || typeof raw !== 'string') return null;
	const trimmed = raw.trim();
	if (!trimmed) return null;

	try {
		const withScheme = /^[a-z][a-z0-9+.-]*:\/\//i.test(trimmed)
			? trimmed
			: `https://placeholder.local/${trimmed.replace(/^\//, '')}`;
		const u = new URL(withScheme);
		const path = (u.pathname || '').toLowerCase();
		if (!path.includes('/profiles/')) {
			return null;
		}
		const id = u.searchParams.get('id');
		if (!id) return null;
		const decoded = decodeURIComponent(id.trim());
		return OBJECT_ID_RE.test(decoded) ? decoded : null;
	} catch {
		return null;
	}
}
